class Helper {
    /**
     * Load script
     * @param scriptUrl
     * @returns {Promise}
     */
    static loadScript(scriptUrl) {
        const SCRIPTS          = document.querySelectorAll('script');
        const SCRIPT           = document.createElement('script');
        const FIRST_SCRIPT_TAG = document.getElementsByTagName('script')[0];

        return new Promise((resolve, reject) => {
            // Check if script is already loaded
            for (let i = 0; i < SCRIPTS.length; i++) {
                if (!scriptUrl.split('//')[1]) break;
                if (scriptUrl.split('//')[1] === SCRIPTS[i].src.split('//')[1]) {
                    resolve();
                    return;
                }
            }
            SCRIPT.src = scriptUrl;
            FIRST_SCRIPT_TAG.parentNode.insertBefore(SCRIPT, FIRST_SCRIPT_TAG);


            SCRIPT.onload = () => {
                resolve();
            };

            SCRIPT.onerror = () => {
                reject();
            };

        });
    }

    /**
     * Check if mobile client
     * @returns {boolean}
     */
    static isMobileClient() {
        return !!(navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i));
    }
}